import styled, { keyframes } from "styled-components";

export const blink = keyframes`
    0%, 100% { opacity: 1 }
    50% { opacity: 0 }
`;

export const ContainerLogo = styled.div`
  width: 100%;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: center;
  flex-grow: 1;
  padding-right: 2.5rem;
  padding-left: 2.5rem;
`;

export const LogoBlink = styled.img`
  animation: ${blink} 1.5s ease-out 0.8s infinite normal;
  width: 50%;
  margin: 0 auto;
`;
